import Partnership from '@/components/Partnership';
import Layout from '../components/Layout';
import API from '../api';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import {getServerSidePaths} from "@/pages/contacts/[slug]";

// Заглушка для переводов
const translate = s => s;

const PartnershipPage = ({ data }) => {
  return <Partnership data={data} />;
};

const breadcrumbs = [
  { title: translate('Главная'), route: '/' },
  { title: translate('Обратная связь'), route: '/feedback' },
];

PartnershipPage.getLayout = (page, t) => (
  <Layout page={page.props} breadcrumbs={breadcrumbs} title={t('Обратная связь — UNIFROST')}>
    {page}
  </Layout>
);

export async function getServerSideProps(context) {
  const props = { data: {} };

  try {
    const res = await API.get(`/v1/api/pages/feedback/`, {
      headers: { 'Accept-Language': context.locale },
    });

    if (res.status === 200) {
      if (res.data) props.data = res.data;
    }
  } catch (error) {}

  return {
    props: {
      ...props,
      ...(await serverSideTranslations(context.locale, ['common', 'menu', 'feedback'])),
    },
    // revalidate: 60,
  };
}

export default PartnershipPage;
